var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1045.9979 197.03482",
    width: 1045.9979,
    height: 197.03482,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 221.14,1.44 171,89.1 H 137.64 V 48.9 H 108.17 V 89.11 H 99.82 V 48.91 H 66.69 L 90.22,89.12 H 59.84 l -24,-43 c 0.77,0.42 10,-2 10,-10.95 0.08,-9.85 -9.4,-11.38 -9.85,-11.36 -0.45,0.02 -5.65,0 -5.65,0 V 89.18 H 2.6 V 1.44 h 42 C 61.31,1.7 71.38,12.6 71.45,26.37 A 23,23 0 0 1 66.35,40.5 H 99.83 V 1.44 h 8.35 V 40.5 h 29.47 V 1.44 h 27.75 v 57.47 a 65.41,65.41 0 0 1 6.07,-15.64 L 192.15,1.44 Z",
    id: "path6",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "416.23,504.04 416.46,504.04 456.42,434.79 471.12,434.79 419.25,521.53 401.63,521.53 401.63,434.79 416.33,434.79 ",
    id: "polygon8",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "521.96,446.45 488.91,446.45 483.8,470.51 514.9,470.51 512.42,482.17 481.32,482.17 475.42,509.87 509.44,509.87 506.96,521.53 459.09,521.53 477.54,434.79 524.44,434.79 ",
    id: "polygon10",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 389.48,1.7 h 30.62 c 12.15,0 21.49,8.14 18,24.42 -2.38,11.17 -10,17.74 -19.76,19.2 l -0.06,0.24 c 8.45,0.85 11.94,5.59 9.84,17.74 -1.07,5.59 -2.4,12.39 -3.26,17.61 -0.66,4.25 1,6.32 2.52,7.53 h -15.64 c -1,-1.58 -1,-4.25 -0.68,-7.65 0.62,-5.22 1.78,-10.08 2.87,-16.4 1.78,-9.48 -0.26,-13.61 -9.74,-13.61 H 392.9 l -8,37.66 H 371 L 389.44,1.7 Z m 16.69,38.63 c 8.87,0 16.07,-5.34 17.92,-14.09 2,-9.23 -2.08,-14.09 -11.19,-14.09 h -11.79 l -6,28.18 z",
    id: "path12",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 773.3,1.7 h 30.62 c 12.14,0 21.48,8.14 18,24.42 -2.38,11.17 -10,17.74 -19.76,19.2 l -0.06,0.24 c 8.44,0.85 11.93,5.59 9.83,17.74 -1.06,5.59 -2.39,12.39 -3.25,17.61 -0.67,4.25 1,6.32 2.52,7.53 h -15.65 c -1,-1.58 -1,-4.25 -0.68,-7.65 0.62,-5.22 1.78,-10.08 2.88,-16.4 1.77,-9.48 -0.26,-13.61 -9.74,-13.61 h -11.3 l -8,37.66 H 754.85 Z M 790,40.33 c 8.87,0 16.06,-5.34 17.92,-14.09 2,-9.23 -2.09,-14.09 -11.2,-14.09 h -11.79 l -6,28.18 z",
    id: "path14",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 460.25,61.6 -0.47,2.18 c -2.25,10.57 1.24,15.92 10.83,15.92 8.75,0 15.52,-5.12 16.89,-11.56 1.93,-9.11 -2.91,-14.2 -10.19,-16.5 l -8.78,-3.28 C 456.93,43.49 452.86,36.94 455.53,24.54 458.88,8.75 470.36,0 486.64,0 c 22.23,0 22.67,16 20.76,25 l -0.4,1.91 h -11.21 l 0.39,-1.82 c 1.68,-7.9 -3.55,-14.67 -12.17,-14.67 -6,0 -12.37,3.28 -14.33,12.51 -1.57,7.41 1.39,11.18 9.34,14.7 l 8.63,3.41 c 11.87,4.37 16.34,14.28 13.8,26.18 -3.92,18.47 -17.26,22.9 -34.76,22.9 -19.12,0 -23.31,-14.34 -20.73,-26.49 l 0.44,-2.06 z",
    id: "path16",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "677.55,521.53 663.71,521.53 682.15,434.79 696,434.79 ",
    id: "polygon18",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 607.35,58.42 -0.39,1.82 c -3.34,15.67 -14,29.91 -34.4,29.91 -21.86,0 -26.74,-17.86 -20.15,-48.84 C 559,10.33 569.87,0 591.86,0 c 17.75,0 21.71,18.23 19.79,27.22 l -0.33,1.57 h -12.78 l 0.31,-1.45 c 1.71,-8 0.71,-17.25 -9.34,-16.89 -10.2,0 -17.24,2.55 -23.18,30.49 -5.94,27.94 -1.75,38.76 8.46,38.76 11.54,0 16.69,-11.8 18.4,-19.82 l 0.3,-1.46 z",
    id: "path20",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "793.31,469.54 818.82,469.54 826.21,434.79 840.06,434.79 821.61,521.53 807.76,521.53 816.34,481.2 790.83,481.2 782.25,521.53 768.4,521.53 786.85,434.79 800.7,434.79 ",
    id: "polygon22",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "905.85,446.45 872.81,446.45 867.69,470.51 898.79,470.51 896.31,482.17 865.21,482.17 859.32,509.87 893.33,509.87 890.85,521.53 842.99,521.53 861.43,434.79 908.33,434.79 ",
    id: "polygon24",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 858.87,1.7 -13.23,62.21 c -2.33,10.93 2.09,15.79 10.47,15.79 8.38,0 13.67,-4.86 16,-15.79 L 885.34,1.7 h 13.85 l -13,61.11 c -4.26,20.05 -15.77,27.34 -32.3,27.34 -16.53,0 -26.13,-7.24 -21.89,-27.34 L 845,1.7 Z",
    id: "path26",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1099.75,499.42 1099.99,499.42 1113.74,434.79 1126.86,434.79 1108.41,521.53 1091.53,521.53 1080.48,455.2 1080.24,455.2 1066.13,521.53 1053.01,521.53 1071.46,434.79 1088.35,434.79 ",
    id: "polygon28",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1025.79,79.78 h -0.24 c -5.47,8 -12.07,10.37 -22.27,10.37 -19,0 -24.91,-14.1 -18.33,-45.07 C 991.53,14.11 1003.29,0 1023.33,0 c 21.75,0 23.9,21.44 22.22,29.34 l -0.33,1.57 h -11 l 0.44,-2.06 c 1.37,-6.44 -2.91,-17.86 -12.38,-17.86 -9.84,0 -17.54,6 -23.43,33.72 -6,27.94 -1.75,35 7.61,35 10.54,0.12 20,-5.92 24,-24.87 H 1013 l 2.21,-10.45 H 1043 c 0,0 -5.81,24.77 -6.8,30.84 -0.74,4.63 -0.33,13.46 -0.33,13.46 h -10.45 l 0.38,-8.9 z",
    id: "path30",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 32.08,175.26 c 0.85,4.32 1.28,9.87 1.89,15.41 h 0.12 c 0.12,-1 0.19,-2.08 0.31,-3.12 0.3,-3.69 0.67,-7.39 1.28,-11.08 l 3.41,-23.6 h 8.84 l -8.47,43.28 H 29.21 L 25.8,179.07 c -0.92,-4.56 -1.22,-9.18 -1.83,-13.8 h -0.12 c -0.61,4.62 -0.92,9.24 -1.83,13.8 L 19,196.15 H 8.72 L 0,152.91 h 8.84 l 3.85,23.6 c 0.61,3.69 1,7.39 1.28,11.08 0.12,1 0.18,2.07 0.24,3.12 h 0.12 c 0.67,-5.54 1.1,-11.09 2,-15.41 l 4.1,-22.39 h 7.08 l 4.57,22.39 z",
    id: "path32",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 81.9,163.6 h 7.92 v 32.55 H 81.9 Z m 0,-10.73 h 7.92 v 6.81 H 81.9 v -6.77 z",
    id: "path34",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 133.66,169.37 h 0.13 a 10.66,10.66 0 0 1 3.11,-4.61 7.09,7.09 0 0 1 4.94,-1.74 v 8.89 c -4.39,-0.4 -7.75,0.63 -7.87,5.43 v 18.81 H 126 V 163.6 h 7.62 v 5.77 z",
    id: "path36",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 217.27,181.03 c 0.06,-11.14 0.18,-18.29 12.13,-18.29 11.77,0 11.84,7.15 11.89,18.29 0.07,11.31 -1.64,16.16 -11.89,16 -10.42,0.18 -12.19,-4.67 -12.13,-16 z m 7.93,4.5 c 0,4 0.36,5.71 4.2,5.71 3.66,0 4,-1.73 4,-5.71 v -10.85 c 0,-3.06 0,-6.17 -4,-6.17 -4.2,0 -4.2,3.11 -4.2,6.17 z m -5.73,-33.18 h 7.74 v 6.64 h -7.74 z m 11.89,0 h 7.8 v 6.64 h -7.8 z",
    id: "path38",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 273.87,169.08 v -5.48 h 3.05 v -3.23 c 0,-5.88 2.56,-7.5 8.35,-7.5 h 3 v 6 a 7.5,7.5 0 0 0 -1.77,-0.34 c -1.16,0 -1.64,0.51 -1.64,1.26 v 3.81 h 3.41 v 5.48 h -3.41 v 27.07 h -7.93 v -27.07 z",
    id: "path40",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 318.87,169.08 v -5.48 h 3.05 v -3.23 c 0,-5.88 2.56,-7.5 8.35,-7.5 h 3 v 6 a 7.5,7.5 0 0 0 -1.77,-0.34 c -1.16,0 -1.64,0.51 -1.64,1.26 v 3.81 h 3.41 v 5.48 h -3.41 v 27.07 h -7.93 v -27.07 z",
    id: "path42",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 374.23,166.91 h 0.13 a 7.46,7.46 0 0 1 7.13,-4.21 c 4.52,0 8.18,2.48 7.93,8.31 v 25.1 h -7.93 v -21.7 c 0,-3.17 -0.36,-5.25 -3.35,-5.37 -2.99,-0.12 -4,2.54 -3.91,6 v 21.06 h -7.92 v -32.5 h 7.92 z",
    id: "path44",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 424.37,174.8 c -0.36,-7.68 3.78,-12.06 11.59,-12.06 11,0 12.19,5.42 12.19,14.31 v 4.38 H 432.3 v 4.73 c 0.06,4.27 1.77,5.08 4.15,5.08 2.92,0 3.78,-2 3.66,-6.11 H 448 c 0.31,7.27 -2.86,11.88 -11,11.88 -9.14,0 -12.86,-4.09 -12.68,-13.67 v -8.54 z m 15.86,0.86 v -2.82 c -0.06,-3.29 -1,-4.33 -4.15,-4.33 -4,0 -3.78,2.88 -3.78,5.82 v 1.33 z",
    id: "path46",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 491.34,166.91 h 0.12 a 7.46,7.46 0 0 1 7.14,-4.21 c 4.51,0 8.17,2.48 7.92,8.31 v 25.1 h -7.92 v -21.7 c 0,-3.17 -0.37,-5.25 -3.36,-5.37 -2.99,-0.12 -4,2.54 -3.9,6 v 21.06 h -7.93 v -32.5 h 7.93 z",
    id: "path48",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "746.23,585.96 746.23,603.1 758.18,603.1 758.18,585.96 766.72,585.96 766.72,629.24 758.18,629.24 758.18,609.45 746.23,609.45 746.23,629.24 737.69,629.24 737.69,585.96 ",
    id: "polygon50",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 650.08,181.03 c 0.07,-11.14 0.19,-18.29 12.14,-18.29 11.77,0 11.83,7.15 11.89,18.29 0.06,11.31 -1.64,16.16 -11.89,16 -10.43,0.18 -12.19,-4.67 -12.14,-16 z m 7.93,4.5 c 0,4 0.36,5.71 4.21,5.71 3.66,0 4,-1.73 4,-5.71 v -10.85 c 0,-3.06 0,-6.17 -4,-6.17 -4.21,0 -4.21,3.11 -4.21,6.17 z",
    id: "path52",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 716.68,169.37 h 0.13 a 10.66,10.66 0 0 1 3.11,-4.61 7.09,7.09 0 0 1 4.94,-1.74 v 8.89 c -4.39,-0.4 -7.75,0.63 -7.87,5.43 v 18.81 h -7.93 V 163.6 h 7.62 z",
    id: "path54",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 758.27,163.6 h 7.93 v 32.55 h -7.93 z m 0,-10.73 h 7.93 v 6.81 h -7.93 v -6.77 z",
    id: "path56",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "973.14,629.24 952.15,629.24 952.15,623.35 964.23,602.46 952.4,602.46 952.4,596.69 973.14,596.69 973.14,602.06 960.57,623.47 973.14,623.47 ",
    id: "polygon58",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-152,-433.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 853.76,181.03 c 0.06,-11.14 0.18,-18.29 12.14,-18.29 11.77,0 11.83,7.15 11.89,18.29 0.06,11.31 -1.65,16.16 -11.89,16 -10.43,0.18 -12.2,-4.67 -12.14,-16 z m 7.93,4.5 c 0,4 0.36,5.71 4.21,5.71 3.65,0 4,-1.73 4,-5.71 v -10.85 c 0,-3.06 0,-6.17 -4,-6.17 -4.21,0 -4.21,3.11 -4.21,6.17 z",
    id: "path60",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 920.73,166.91 h 0.12 a 7.47,7.47 0 0 1 7.13,-4.21 c 4.52,0 8.18,2.48 7.93,8.31 v 25.1 H 928 v -21.7 c 0,-3.17 -0.36,-5.25 -3.35,-5.37 -2.99,-0.12 -4,2.54 -3.9,6 v 21.06 h -7.93 v -32.5 h 7.93 v 3.31 z",
    id: "path62",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 983,196.26 c -4.7,0.53 -11.28,0.93 -11.28,-5.13 v -22.05 h -3.23 v -5.48 h 3.16 v -8.94 h 8 v 8.94 H 983 v 5.48 h -3.35 v 20.2 c 0.18,1.39 2.37,1.21 3.35,1.1 z",
    id: "path64",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1015.86,174.8 c -0.36,-7.68 3.78,-12.06 11.59,-12.06 11,0 12.2,5.42 12.2,14.31 v 4.38 h -15.86 v 4.73 c 0.06,4.27 1.77,5.08 4.14,5.08 2.93,0 3.79,-2 3.67,-6.11 h 7.92 c 0.31,7.27 -2.86,11.88 -11,11.88 -9.15,0 -12.87,-4.09 -12.69,-13.67 v -8.54 z m 15.86,0.86 v -2.82 c -0.07,-3.29 -1,-4.33 -4.15,-4.33 -4,0 -3.78,2.88 -3.78,5.82 v 1.33 z",
    id: "path66",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRv);
export default __webpack_public_path__ + "static/media/r+v.7e82d3c6e089810201aa09704cadee9f.svg";
export { ForwardRef as ReactComponent };